import React from 'react'
import { t } from '../../../i18n'
import { admin_command_step_durations_path } from '../../../../routes'

const scope = 'command_history'

type ExportParams = Record<string, string | number | null | undefined>

// Same params as the tab's data request, minus paging: the export is the whole filtered set.
const exportUrl = (params: ExportParams): string => {
  const query: Record<string, string> = { format: 'xlsx' }

  Object.entries(params).forEach(([key, value]) => {
    if (key === 'page' || key === 'format' || value == null || value === '')
      return
    query[key] = String(value)
  })

  return admin_command_step_durations_path(query)
}

const ExportToExcelButton = ({ params }: { params: ExportParams }) => (
  <a className="btn btn-primary" href={exportUrl(params)}>
    <i className="fas fa-file-excel me-2" />
    {t('export_to_excel', { scope })}
  </a>
)

export default ExportToExcelButton
